/** External accessibility resources shown in Tour Planner filter panels. */
export const ACCESSIBILITY_LINKS = [
  {
    id: 'metro-accessible',
    label: 'Is The Metro Accessible?',
    url: 'https://www.isthemetroaccessible.com',
  },
];

export const openAccessibilityLink = (url) => {
  if (typeof window !== 'undefined' && typeof window.open === 'function') {
    window.open(url, '_blank', 'noopener,noreferrer');
    return;
  }
  const { Linking } = require('react-native');
  Linking.openURL(url);
};
